import React, {useEffect, useState} from "react";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import {initReactI18next} from "react-i18next";
import {Preloader} from "views/components/Preloader/preloader.component";
import {GAME_ZONE_URL} from "data/constants";
import {languageDetectorByUrl} from "data/utils";
import {first} from "lodash";

const languageDetector = new LanguageDetector();
languageDetector.addDetector(languageDetectorByUrl);

interface IProps {
	children: React.ReactNode;
}

export const HOCi18n: React.FC<IProps> = ({children}) => {
	const [initialized, setInitialized] = useState(false);

	useEffect(() => {
		void i18n
			.use(initReactI18next)
			.use(Backend)
			.use(languageDetector)
			.init(
				{
					/**
					 * i18nextBrowserLanguageDetector
					 */
					returnNull: false,
					detection: {
						order: [
							"languageDetectorByUrl",
							"cookie",
							"localStorage",
							"sessionStorage",
							"navigator",
						],
					},
					supportedLngs: ["en", "fr"],
					backend: {
						crossDomain: true,
						loadPath: (_: string[], namespaces: string[]) => {
							if (first(namespaces) === "gamezone") {
								return `${GAME_ZONE_URL}json/langs/{{lng}}.json`;
							}

							return `${GAME_ZONE_URL}json/{{ns}}/langs/{{lng}}.json`;
						},
					},
					ns: ["pickem", "gamezone"],
					defaultNS: "pickem",
					fallbackLng: "en",
					debug: false,
					keySeparator: ".",
					interpolation: {
						escapeValue: false,
						formatSeparator: ",",
					},
				},
				() => {
					setInitialized(true);
				}
			);
	}, []);

	return initialized ? <React.Fragment>{children}</React.Fragment> : <Preloader />;
};
